import { hydrate } from "preact";
import { pages } from "./pages";
import { window } from "./common/global";
import { AppStateProvider } from "./common/app-state";
import { App } from "./components/app";

window.renderPage = async (pageName: keyof typeof pages) => {
	const children = await pages[pageName].component();
	hydrate(
		<AppStateProvider setupProps={{}}>
			<App>{children}</App>
		</AppStateProvider>,
		document.body
	);
};
